import { useEffect, useState } from 'react';

const localStorageKey = 'isUserDissmissedOrInteractedWithPcaChat';

export const useUserInteractionWithPcaChat = () => {
  // keep the default value as true because we don't want to show the tooltip and hide it if the user already interacted with the chat
  const [isInteracted, setIsInteracted] = useState(true);

  useEffect(() => {
    const isInteracted = localStorage.getItem(localStorageKey) === 'true';
    setIsInteracted(isInteracted);
  }, []);

  const setUserInteracted = () => {
    localStorage.setItem(localStorageKey, 'true');
    setIsInteracted(true);
  };

  return { isInteracted, setUserInteracted };
};
